import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	modalTitle: {
		id: 'hub-home.discard-changes-modal.title.v2',
		defaultMessage: 'You have unpublished changes',
		description: 'Title for the modal asking user to confirm discarding unsaved changes',
	},
	modalDescription: {
		id: 'hub-home.discard-changes-modal.description.v2',
		defaultMessage:
			'If you leave this page without publishing your changes, they will be lost and your site will revert to the last published version.',
		description: 'Description explaining what happens if user leaves without saving',
	},
	keepEditingButton: {
		id: 'hub-home.discard-changes-modal.keep-editing-button',
		defaultMessage: 'Keep editing',
		description: 'Button text to continue editing without discarding changes in studio',
	},
	leaveWithoutSavingButton: {
		id: 'hub-home.discard-changes-modal.leave-without-saving-button',
		defaultMessage: 'Discard changes',
		description: 'Button text to leave and discard all unsaved changes',
	},
});

export default messages;
